import { Component, Input } from '@angular/core';
import { FormControl, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteOffInputDirective } from 'app/shared/form-utils/autocomplete-off.directive';
import { IsInvalidControlDirective } from 'app/shared/form-utils/is-invalid.directive';
import { NumberDirective } from 'app/shared/form-utils/number.validator';

@Component({
    selector: 'form-number-range',
    imports: [
        NumberDirective,
        FormsModule,
        AutocompleteOffInputDirective,
        IsInvalidControlDirective,
        ReactiveFormsModule,
    ],
    host: {
        class: 'd-block',
    },
    template: `
        <div class="form-group" [class.is-invalid]="controlFrom.invalid || controlTo.invalid">
            <ng-content select="label"></ng-content>
            <ng-content select="i.fa"></ng-content>
            <div class="form-range">
                <span class="input-group">
                    <span class="input-group-prepend">
                        <span class="input-group-text">Min</span>
                    </span>
                    <input [attr.id]="formControlFrom" class="form-control" type="ui-number" min="0" [max]="maxInt64" [formControl]="controlFrom">
                </span>
                <span class="dash">&ndash;</span>
                <span class="input-group">
                    <span class="input-group-prepend">
                        <span class="input-group-text">Max</span>
                    </span>
                    <input [attr.id]="formControlTo" class="form-control" type="ui-number" min="0" [max]="maxInt64" [formControl]="controlTo">
                </span>
                <ng-content></ng-content>
            </div>
            <small class="invalid-feedback">Please enter positive number</small>
            <ng-content select="small.form-text"></ng-content>
        </div>
    `,
})
export class FormNumberRangeComponent {

    @Input() formControlFrom: string;

    @Input() formControlTo: string;

    maxInt64: number = 2 ** 63 - 1;

    get controlFrom() {
        return this.formGroup.control.get(this.formControlFrom) as FormControl;
    }

    get controlTo() {
        return this.formGroup.control.get(this.formControlTo) as FormControl;
    }

    constructor(public formGroup: FormGroupDirective) {}
}
